module.exports = __webpack_public_path__ + "static/media/Board of Studies_2018-19.43a43b33.pdf";